import {styled} from "@mui/styles";
import {InputBase} from "@mui/material";

export const SearchInputBase = styled(InputBase)(({ theme }) => ({
    fontSize: 14,
    height: 18,

    '&.MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        //paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        height: 18
    },
}));